export default {
  // Table column headers
  transactionHash: "Transaction Hash",
  sender: "Sender",
  receiver: "Receiver",
  currency: "Currency",
  transactionAmount: "Transaction Amount",
  transactionTime: "Transaction Time",

  // Loading and status
  loading: "Loading...",
  noData: "No data",
  tooMuchData:
    "Too much transaction data for this address, only conditional queries with sender/receiver address are supported",

  // Download
  downloadDetails: "Download Details",
  downloadNote: "Note: Maximum 100,000 records can be downloaded",

  // Message prompts
  copySuccess: "Copy successful!",
};
